// src/pages/painel/componentes/AdicionarRefeicaoModal.js
import React, { useState, useRef, useEffect } from 'react';
import './adicionarrefeicao.css';

import AdicionarRefeicaoFavorito from './AdicionarRefeicaoFavorito';

const API_BASE = process.env.REACT_APP_API_BASE;

const AdicionarRefeicaoModal = ({
  onClose,
  atualizarCalorias,
  onRefeicaoSalva,
  prefill,
  saldoMoedas = 0,
  custoMoedasPorCalculo = 2,
  onCalculoRealizado,
  xpPorCalculo = 0,
  xpPorRefeicao = 0,
}) => {

  const [modo, setModo] = useState('digitar');

  const [refeicaoTipoId, setRefeicaoTipoId] = useState(1);
  const [descricaoOriginal, setDescricaoOriginal] = useState('');

  const [carregando, setCarregando] = useState(false);
  const [calculado, setCalculado] = useState(null);
  const [erro, setErro] = useState('');

  const [textoUsadoNoCalculo, setTextoUsadoNoCalculo] = useState('');

  const [origemCalculo, setOrigemCalculo] = useState('gpt');
  const [pagoComMoedaCalculo, setPagoComMoedaCalculo] = useState(false);

  useEffect(() => {
    if (!prefill) return;

    setModo('digitar');

    if (prefill.tipo_refeicao) {
      const mapTipo = {
        cafe: 1,
        almoco: 2,
        jantar: 3,
        lanche: 4,
      };
      setRefeicaoTipoId(mapTipo[prefill.tipo_refeicao] || 2);
    }

    if (prefill.texto) {
      setDescricaoOriginal(prefill.texto);
      setTextoUsadoNoCalculo(prefill.texto);
    }

    if (prefill.calorias && prefill.macros) {
      setCalculado({
        calorias_total: prefill.calorias,
        proteinas_total: prefill.macros.proteina_g,
        carboidratos_total: prefill.macros.carbo_g,
        gorduras_total: prefill.macros.gordura_g,
        itens: []
      });
      setOrigemCalculo('tabela');
      setPagoComMoedaCalculo(false);
    }

    setErro('');
  }, [prefill]);

  const [instrucoesAbertas, setInstrucoesAbertas] = useState(true);

  const [isRecording, setIsRecording] = useState(false);
  const [isTranscribing, setIsTranscribing] = useState(false);
  const recognitionRef = useRef(null);

  const descricaoAtual = descricaoOriginal.trim();
  const textoBase = (textoUsadoNoCalculo || '').trim();
  const descricaoPreenchida = descricaoAtual.length > 0;

  const resultadoAtualizado =
    !!calculado && descricaoPreenchida && descricaoAtual === textoBase;

  const saldoInsuficiente = saldoMoedas < custoMoedasPorCalculo;

  useEffect(() => {
    const salvo = localStorage.getItem("modalAddRef_instrucoesAbertas");
    if (salvo !== null) {
      setInstrucoesAbertas(salvo === "true");
    }
  }, []);

  const toggleInstrucoes = () => {
    const novo = !instrucoesAbertas;
    setInstrucoesAbertas(novo);
    localStorage.setItem("modalAddRef_instrucoesAbertas", novo.toString());
  };

  const calcularRefeicao = async () => {
    if (!descricaoAtual) {
      setErro('Descreva o que você comeu para calcular a refeição.');
      return;
    }

    setCarregando(true);
    setErro('');
    setCalculado(null);

    try {
      const res = await fetch(`${API_BASE}/requestia.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          refeicao_tipo_id: refeicaoTipoId,
          descricao_original: descricaoOriginal,
        }),
      });

      const data = await res.json();

      if (data.status === 'sucesso') {
        setCalculado(data.dados);
        setTextoUsadoNoCalculo(descricaoOriginal);
        setOrigemCalculo('gpt');
        setPagoComMoedaCalculo(!!data.pago_com_moeda);
        onCalculoRealizado?.();
      } else {
        setErro(data.mensagem || 'Erro ao calcular a refeição.');
      }
    } catch {
      setErro('Erro ao comunicar com o servidor.');
    }

    setCarregando(false);
  };

  const salvarRefeicao = async () => {
    if (!calculado || !resultadoAtualizado) return;

    setCarregando(true);
    setErro('');

    try {
      const res = await fetch(`${API_BASE}/salvar-refeicao.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          refeicao_tipo_id: refeicaoTipoId,
          descricao_original: descricaoOriginal,
          calorias_total: calculado.calorias_total,
          proteinas_total: calculado.proteinas_total,
          carboidratos_total: calculado.carboidratos_total,
          gorduras_total: calculado.gorduras_total,
          detalhes_itens_json: JSON.stringify(calculado.itens),
          origem_calculo: origemCalculo,
          pago_com_moeda: origemCalculo === 'gpt' ? pagoComMoedaCalculo : false,
        }),
      });

      const data = await res.json();

      if (data.status === 'sucesso') {
        atualizarCalorias?.();
        onRefeicaoSalva?.(data.novas_conquistas || []);
        onClose();
      } else {
        setErro(data.mensagem || 'Erro ao salvar a refeição.');
      }
    } catch {
      setErro('Erro ao comunicar com o servidor.');
    }

    setCarregando(false);
  };

  const startVoiceInput = () => {
    if (isRecording || isTranscribing) return;

    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      setErro('Seu navegador não suporta reconhecimento de voz.');
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = 'pt-BR';
    recognition.interimResults = true;
    recognition.continuous = true;

    let finalTranscript = '';

    recognition.onstart = () => {
      setErro('');
      setIsRecording(true);
    };

    recognition.onresult = (event) => {
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const result = event.results[i];
        if (result.isFinal) finalTranscript += result[0]?.transcript + ' ';
      }
    };

    recognition.onend = () => {
      setIsRecording(false);
      const textoLimpo = finalTranscript.trim();
      if (!textoLimpo) return;

      setIsTranscribing(true);
      setTimeout(() => {
        setDescricaoOriginal(prev =>
          prev.trim() ? prev.trim() + ' ' + textoLimpo : textoLimpo
        );
        setIsTranscribing(false);
      }, 600);
    };

    recognitionRef.current = recognition;
    recognition.start();
  };

  const handleMicClick = () => {
    if (isRecording) recognitionRef.current?.stop();
    else startVoiceInput();
  };

  return (
    <div className="modal-fundo">
      <div className="modal-referencia">

        <button className="modal-fechar" onClick={onClose}>×</button>

        <h2>Adicionar Refeição</h2>

        <div className="modo-toggle">
          <button
            className={modo === 'digitar' ? 'ativo' : ''}
            onClick={() => setModo('digitar')}
          >
            ✍️ Digitar refeição
          </button>

          <button
            className={modo === 'favorito' ? 'ativo' : ''}
            onClick={() => setModo('favorito')}
          >
            ⭐ Usar favorito
          </button>
        </div>

        {modo === 'favorito' && (
          <AdicionarRefeicaoFavorito
            onClose={onClose}
            atualizarCalorias={atualizarCalorias}
            onRefeicaoSalva={onRefeicaoSalva}
            xpPorRefeicao={xpPorRefeicao}
          />
        )}

        {modo === 'digitar' && (
          <>
            <div className="instrucoes-header" onClick={toggleInstrucoes}>
              <span>{instrucoesAbertas ? "Ocultar instruções" : "Mostrar instruções"}</span>
              <span className="setinha">{instrucoesAbertas ? "▲" : "▼"}</span>
            </div>

            {instrucoesAbertas && (
              <p className="modal-explicacao">
                Descreva sua refeição com detalhes:
                <br />• Quantidade aproximada (g, colheres, fatias...)
                <br />• Modo de preparo (cozido, grelhado, frito...)
                <br />• Bebidas e acompanhamentos
              </p>
            )}

            <label>Tipo de refeição:</label>
            <select
              value={refeicaoTipoId}
              onChange={(e) => setRefeicaoTipoId(Number(e.target.value))}
            >
              <option value={1}>Café da manhã</option>
              <option value={2}>Almoço</option>
              <option value={3}>Jantar</option>
              <option value={4}>Lanche</option>
            </select>

            <label>O que você comeu?</label>
            <div className="descricao-voz-container">
              <textarea
                placeholder="Ex: 100g de arroz branco cozido + 100g de feijão cozido..."
                value={descricaoOriginal}
                onChange={(e) => setDescricaoOriginal(e.target.value)}
              />

              <button
                type="button"
                className={`mic-button ${isRecording ? 'mic-button--active' : ''}`}
                onClick={handleMicClick}
              >
                🎤
              </button>
            </div>

            {erro && <p className="erro-msg">{erro}</p>}

            {/* 🆕 botão agora sempre aparece; fica DESATIVADO quando falta saldo */}
            {!carregando && descricaoPreenchida && !resultadoAtualizado && (
              <button
                className="btn-calcular"
                onClick={calcularRefeicao}
                disabled={saldoInsuficiente}
              >
                {saldoInsuficiente ? (
                  "Saldo insuficiente"
                ) : (
                  <>
                    {calculado ? 'Recalcular' : 'Calcular refeição'}
                    {' '}
                    <img src="/moeda.png" alt="moeda" className="icone-moeda-botao" />
                    {' '}{custoMoedasPorCalculo}
                  </>
                )}
              </button>
            )}

            {/* 🆕 link de recarga, só quando o saldo está insuficiente */}
            {!carregando && descricaoPreenchida && !resultadoAtualizado && saldoInsuficiente && (
              <a href="/acesso" className="link-recarregar-moedas">
                Recarregar moedas →
              </a>
            )}

            {!carregando && descricaoPreenchida && !resultadoAtualizado && !saldoInsuficiente && xpPorCalculo > 0 && (
              <p className="label-xp-ganho">✨ +{xpPorCalculo} XP ao calcular</p>
            )}

            {carregando && (
              <div className="loading-container">
                <div className="spinner"></div>
                <p>Calculando...</p>
              </div>
            )}

            {calculado && !carregando && resultadoAtualizado && (
              <div className="resultado-container">
                <div className="resultado-kcal">
                  <strong>{calculado.calorias_total} kcal</strong>
                </div>

                <div className="macros-grid">
                  <div className="macro">
                    <span>Proteínas</span>
                    <strong>{calculado.proteinas_total} g</strong>
                  </div>
                  <div className="macro">
                    <span>Carboidratos</span>
                    <strong>{calculado.carboidratos_total} g</strong>
                  </div>
                  <div className="macro">
                    <span>Gorduras</span>
                    <strong>{calculado.gorduras_total} g</strong>
                  </div>
                </div>

                <button className="btn-salvar" onClick={salvarRefeicao}>
                  Salvar refeição
                </button>

                {xpPorRefeicao > 0 && (
                  <p className="label-xp-ganho">✨ +{xpPorRefeicao} XP ao salvar</p>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AdicionarRefeicaoModal;